import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { AmlService } from '../_services/aml.service';
import { AmlTaskEnum } from '../_models/aml-task.enum';
import { SpidTaskEnum } from '../_models/spid-task.enum';

export const signProcessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const amlService = inject(AmlService);

  const processId = route.paramMap.get('processId');
  const praticaId = route.paramMap.get('praticaId');
  console.log('guard is checking');
  if (processId && praticaId) {
    amlService.processId = processId;
    amlService.idPratica = praticaId;
    if (route.firstChild && amlService.nextTask) {
      return true;
    }
    return amlService.getActiveTask().pipe(
      switchMap((res) => {
        if (
          res?.name === AmlTaskEnum.SIGN_OR_SEND ||
          res?.name === AmlTaskEnum.START_PROCESS ||
          res?.name === SpidTaskEnum.START_PROCESS
        ) {
          return amlService.nextAction(res, { action: 'SIGN' });
        } else {
          return of(res);
        }
      }),
      map((res) => {
        const path = amlService.getPath(res);
        const destination = path[0];
        router.navigateByUrl(destination);
        return false;
      }),
      catchError((err) => {
        return of(router.createUrlTree(['error']));
      })
    );
  } else {
    return router.createUrlTree(['error']);
  }
};
